import { Table, Tag, Space, message } from "antd";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { ColumnsType } from "antd/es/table";
import { useTranslation } from "react-i18next";
import {
  deletePriceScheme,
  getPriceSchemeById,
} from "../../../api/pricescheme";
import { UseMutateAsyncFunction, useMutation } from "react-query";
import { AddEditPrice } from "./AddEditPriceScheme";
import { PriceType } from "./priceType";
import EditButton from "../../UI/EditButton/editbutton";
import DeleteButton from "../../UI/DeleteButton/deletebutton";
import DeleteModal from "../../UI/ModalComponent/DeleteModal/deletemodal";
import { AxiosResponse } from "axios";

interface inventoryProps {
  page: number;
  setPage: Dispatch<SetStateAction<number>>;
  filter: boolean | undefined;
  search: string;
  istPriceSchemeLoading: boolean;
  paginatedtPriceScheme: any;
  setPaginatedtPriceScheme: Dispatch<any>;
  PriceSchemeMutation: UseMutateAsyncFunction<
    AxiosResponse<any, any>,
    unknown,
    {
      limit: number;
      q: string;
      isActive?: boolean | undefined;
    },
    unknown
  >;
  tableKey: string;
}
interface PriceSchemeInterface {
  id: number;
  name: string;
  description: string;
  isActive: boolean;
}
const PriceSchemeList = ({
  page,
  search,
  setPage,
  filter,
  istPriceSchemeLoading,
  paginatedtPriceScheme,
  setPaginatedtPriceScheme,
  PriceSchemeMutation,
  tableKey,
}: inventoryProps) => {
  const [t] = useTranslation("common");
  const [openPrice, setOpenPrice] = useState(false);
  const [selectedPrice, setSelectedPrice] = useState<any>();
  const [price, setPrice] = useState<PriceType>();
  const [prevPage, setPrevPage] = useState<number>(0);
  const [maxPage, setMaxPage] = useState<number>(0);
  const [, setError] = useState("");
  const [open, setOpen] = useState(false);
  const [idToDelete, setIdToDelete] = useState<string | undefined>(undefined);
  const [nameToDelete, setNameToDelete] = useState<any>();

  useEffect(() => {
    page > prevPage &&
      maxPage < page &&
      PriceSchemeMutation({
        limit: page * 8 + 8,
        q: search,
        isActive: filter,
      }).then((res) => {
        if (page > maxPage) setMaxPage(page);
        setPaginatedtPriceScheme(res.data?.data);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, filter]);

  const onError = (error: any, context: unknown) => {
    if (setError) {
      setError(error.response.data.message);
      message.error({
        content: error.response.data.message,
        duration: 10,
        onClick: () => {
          message.destroy();
        },
      });
    }
  };

  const deletePriceSchemeMutation = useMutation(
    "deletePriceScheme",
    deletePriceScheme,
    {
      onSuccess: () => {
        PriceSchemeMutation({
          limit: page * 8 + 8,
          q: search,
          isActive: filter,
        }).then((res) => {
          setPaginatedtPriceScheme(res.data?.data);
          message.success("Complete successfully");
        });
      },
      onError,
    }
  );

  const DeletePrice = (id: string | undefined, name: string): void => {
    setOpen(true);
    setIdToDelete(id);
    setNameToDelete(name);
  };

  const handleOk = () => {
    if (idToDelete) {
      deletePriceSchemeMutation.mutate({ id: idToDelete });
    }
    setOpen(false);
  };

  const getPriceSchemeMutation = useMutation(
    "getPriceScheme",
    getPriceSchemeById
  );
  function fillPriceScheme(id: any) {
    getPriceSchemeMutation.mutate(id, {
      onSuccess: (res) => {
        setPrice(res.data);
        setOpenPrice(true);
      },
    });
  }

  const columns: ColumnsType<PriceSchemeInterface> = [
    {
      title: `${t("name")}`,
      dataIndex: "name",
      key: "name",
      width: "30rem",
      className: "table-header",
    },
    {
      title: `${t("description")}`,
      dataIndex: "description",
      key: "description",
    },
    {
      title: `${t("status")}`,
      dataIndex: "isActive",
      align: "center",
      width: "5rem",
      key: "isActive",
      render: (record: any) =>
        record ? (
          <Tag className="active">Active</Tag>
        ) : (
          <Tag className="inactive">Inactive</Tag>
        ),
    },
    {
      title: `${t("action")}`,
      key: "action",
      fixed: "right",
      align: "center",
      width: "5rem",
      render: (record: any) => (
        <Space>
          <EditButton
            onClick={() => {
              fillPriceScheme(record.id);
              setSelectedPrice(record.id);
            }}
          />
          <DeleteButton onClick={() => DeletePrice(record?.id, record?.name)} />
        </Space>
      ),
    },
  ];
  return (
    <>
      <DeleteModal
        open={open}
        setOpen={setOpen}
        name={nameToDelete}
        onOk={handleOk}
      />
      {openPrice && price && (
        <AddEditPrice
          price={price}
          openPrice={openPrice}
          setOpenPrice={setOpenPrice}
          id={selectedPrice}
          page={page}
          filter={filter}
          search={search}
          setPaginatedtPriceScheme={setPaginatedtPriceScheme}
          PriceSchemeMutation={PriceSchemeMutation}
        />
      )}
      <Table
        key={tableKey}
        scroll={{ x: 1000 }}
        pagination={{ pageSize: 8 }}
        columns={columns}
        dataSource={paginatedtPriceScheme}
        loading={istPriceSchemeLoading}
        rowClassName={(record, index) =>
          index % 2 === 0
            ? "table-row-light table-row"
            : "table-row-dark table-row"
        }
        onChange={(selectedPage) => {
          setPrevPage(page);
          setPage(selectedPage?.current ?? 1);
        }}
        rowKey={(record) => record.id}
      />
    </>
  );
};

export default PriceSchemeList;
